import { lazy } from 'react';

export const NavigateYourLovePageLazy = lazy(() => import('./navigate-your-love'));
